import { BrandHeader, Container, IconBox, Wrapper } from "./styles";
import { Divider } from "@mui/material";
import { Button } from "@alterdomus-analytics/dna-ui";
import folders from "../../assets/images/folders.svg";
import clipboard from "../../assets/images/clipboard.svg";
import avatars from "../../assets/images/avatars.svg";
import cvxLogo from "../../assets/images/cvxLogo.png";
import ADlogo from "../../assets/images/ADlogo.png";
import { useNavigate } from "react-router-dom";

export const SessionTimeoutPage = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <BrandHeader>
        <img src={cvxLogo} alt="CVX logo" width="220" height="22" />
        <Divider orientation="vertical" flexItem />
        <h3>an alter domus technology</h3>
      </BrandHeader>
      <Container>
        <h1>Session Expired</h1>
        <p>Your user has been logged out after being idle, please log-in again.</p>
        <Button
          label="Back to Login Page"
          variantType="primary"
          href="/"
          e2e-test-id="cvx-login-button"
          onClick={() => navigate("/")}
        />
        <IconBox>
          <img src={folders} alt="files" />
          <img src={clipboard} alt="clipboard" />
          <img src={avatars} alt="users" />
        </IconBox>
      </Container>
      <BrandHeader>
        <img src={ADlogo} alt="CVX logo" width="148" height="20" />
      </BrandHeader>
    </Wrapper>
  );
};
